export default __webpack_public_path__ + "static/media/fbtk_cark.f530b8c2.png";